import React, { Component } from 'react'
import { countryList, getCookie } from '../../../../util/utils'
import './index.less'

class CountrySelect extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	componentDidMount(){
		// console.log(countryList,'ddd');
	}

	handleCountrySelect = (e) => {
		this.props.changeCountry(e.target.value)
	}

	render(){
		var currentLang = getCookie('seller_site_lang')?getCookie('seller_site_lang').split('-')[0]:'zh'
		return (
			<select className='retrieveusername-info-countryselect' onChange={this.handleCountrySelect}>
				{
					countryList.map((item, index) => {
						return <option value={`${item.areacode}-${item.countrycode}`} key={index}>{currentLang=='zh'?item.name:item.enname}{item.areacode}</option>
					})
				}
			</select>
		)
	}
}
export default CountrySelect